import Vue from 'vue';

export default order => Vue.$http
    .post('Google/createEvent', order);



// WEBPACK FOOTER //
// ./src/services/order/createEvent.js